import {useEffect} from "react";
import {Control, Controller} from "react-hook-form";
import {AutoComplete} from "primereact/autocomplete";
import {classNames} from "primereact/utils";
import "./AutocompleteInput.scss";

export interface AutocompleteInputProps {
    id: string;
    value: string;
    onValueChange: (property: string, value: string[]) => void;
    labelText: string;
    sugestions: string[];
    multiple?: boolean;
    completeMethod: (e: any) => void;
    placeholder?: string;
    control: Control;
    setValue?: any;
    errors: any;
    rules?: any;
    disabled?: boolean;
};

export const AutocompleteInput = (p: AutocompleteInputProps) => {
    const {
            id,
            value,
            onValueChange,
            sugestions,
            multiple,
            completeMethod,
            placeholder,
            labelText,
            control,
            setValue,
            errors,
            rules,
            disabled
        } = p;

        useEffect(() => {
            if (setValue) setValue(labelText, value)
        }, [value]);

    return (
        <div className="autocomplete-input">
            <label
                className={classNames("autocomplete-label", {
                    'p-error': errors[labelText],
                })}
                htmlFor={id}
            >
                {labelText}
            </label>
            <Controller
                name={labelText}
                control={control}
                rules={rules}
                render={({ field, fieldState }) => (
                    <AutoComplete
                        {...field}
                        id={id}
                        value={value}
                        suggestions={sugestions}
                        multiple={multiple}
                        completeMethod={completeMethod}
                        onChange={(e)=>{
                            onValueChange(id, e.value)
                        }}
                        placeholder={placeholder}
                        className={classNames('autocomplete-input-field', { 'p-invalid': fieldState.invalid })}
                        disabled={disabled}
                        />
                    )
                }
            />
        </div>
    );
};
